import { render } from "./TariffListPage.vue?vue&type=template&id=24b8c268"
import script from "./TariffListPage.vue?vue&type=script&lang=js"
export * from "./TariffListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__